import React from "react";
import elos from "./img/jaxa_elos2_pub.webp";

const SatelliteOrbit = () => {
  return (
    // <div className="absolute ml-[10vw] w-2/12 z-30 outline outline-3">
    //   <div className="relative m-auto w-40 h-32 overflow-visible">
    <div className="absolute ml-10 w-72 h-72 z-30 bottom-10 overflow-hidden">
    {/* <div className="absolute ml-10 w-72 h-72 z-30 bottom-10 overflow-hidden outline outline-1"> */}
        <style>{`
          @keyframes orbit-rot {
            from { transform: rotate(0deg); }
            to   { transform: rotate(360deg); }
          }

          @keyframes orbit-rot-rev {
            from { transform: rotate(0deg); }
            to   { transform: rotate(-360deg); }
          }

          /* 軌道フレーム（これだけ回す） */
          .orbit-frame {
            position: absolute;
            inset: 0;
            animation: orbit-rot 20s linear infinite;
            transform-origin: 50% 50%;
            will-change: transform;
          }

          /* 衛星：逆回転で姿勢を固定 */
          .sat-img {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 128px;
            height: 128px;

            transform: translate(-50%, -50%) translateX(50px);
            animation: orbit-rot-rev 20s linear infinite;
            will-change: transform;
          }
        `}</style>

        <a
          href="https://www.eorc.jaxa.jp/ALOS/jp/alos-2/a2_about_j.htm"
          target="_blank"
          rel="noreferrer"
          className="orbit-frame"
        >
          <img src={elos} alt="Satellite" className="sat-img" />
        </a>
      </div>
    // </div>
  );
};

export default SatelliteOrbit;
